export const getEnvironment = (): string => {
  // Prioritize build-time environment variable
  if (process.env.REACT_APP_ENV) {
    return process.env.REACT_APP_ENV;
  }

  const hostname = window.location.hostname;

  if (hostname === 'dev.spinba.se' || hostname.startsWith('dev.')) {
    return 'dev';
  }
  if (hostname === 'stg.spinba.se' || hostname.startsWith('stg.')) {
    return 'stg';
  }
  if (
    hostname === 'spinba.se' ||
    hostname === 'www.spinba.se' ||
    hostname === 'spinbase.eu' ||
    hostname === 'www.spinbase.eu'
  ) {
    return 'prod';
  }

  // Default to dev for local development or unknown hostnames
  return 'dev';
};
